import React from "react";
import '../../../../../common/AccountPageStateStyle.css';
import {Container, InfoIcon, SuccessIcon, Text, WarningIcon} from "@myob/myob-widgets";
import OpenBankingAccountResultTable from "./OpenBankingAccountResultTable";

const OpenBankingAccountSummaryContainer = ({resultStatus, accounts}) => {
  const getTitle = (Icon, color, text) => (
    <div className="title-container" style={{fontWeight: 500}}>
      <Icon color={color} style={{marginRight: '8px'}}/>
      <span>{text}</span>
    </div>
  );

  const resultStatuses = {
    unsupportedAccounts: {
      title: getTitle(WarningIcon, "warning", "Unsupported accounts"),
      description: (
        <Text className="description-container">
          We're unable to connect these types of accounts.
        </Text>
      )
    },
    consentExtended: {
      title: getTitle(SuccessIcon, "success", "Consent extended"),
      description: (
        <Text className="description-container">
          Nothing's changed for these accounts.
        </Text>
      )
    },
    selected: {
      title: getTitle(SuccessIcon, "success", "Accounts connected"),
      description: (
        <Text className="description-container">
          Bank transactions for these accounts will be visible in MYOB soon.
        </Text>
      ),
    },
    unselected: {
      title: getTitle(WarningIcon, "warning", "Not connected"),
      description: (
        <Text className="description-container">
          These accounts couldn’t be connected. We won’t import any data for these accounts.
        </Text>
      ),
    },
    disconnectedAccounts: {
      title: getTitle(InfoIcon, "info", "Accounts disconnected"),
      description: (
        <Text className="description-container">
          As you have removed these bank accounts in the consent, the connected accounts will now be disconnected and no new data will be saved.
        </Text>
      ),
    },
  }

  return (
    <Container style={{marginBottom: "40px"}}>
      {resultStatuses[resultStatus]?.title}
      {resultStatuses[resultStatus]?.description}
      <OpenBankingAccountResultTable accountsData={accounts}/>
    </Container>
  );
};

export default OpenBankingAccountSummaryContainer;
